import { type RefObject } from "react";
import type { ITabsItem } from "./types";

export function getActiveButton(
  activeIndex: number,
  items: ITabsItem[],
  tabButtonRefs: RefObject<Map<string, HTMLButtonElement>>,
): HTMLButtonElement | null {
  if (activeIndex < 0) return null;
  const id = items[activeIndex]?.id;
  if (!id) return null;
  return tabButtonRefs.current?.get(id) ?? null;
}
